import type { ReactNode } from "react";
import { useChatSocket } from "../hooks/useChatSocket";
import { ChatSocketContext } from "./ChatSocketContext";

export function ChatSocketProvider({ children }: { children: ReactNode }) {
  const value = useChatSocket();
  return (
    <ChatSocketContext.Provider value={value}>
      {children}
    </ChatSocketContext.Provider>
  );
}
